// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_GjVcd","item":"item_qbpTI","link":"link_Co56K","separator":"separator_uws4w"};